import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

import "./Verificacoes.css";

export default function Verificacoes() {
  const [verificacoes, setVerificacoes] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  // =========================================================
  // 🔥 Carrega usuários que possuem verificationStatus
  // (pending, verified, rejected)
  // =========================================================
  async function loadData() {
    try {
      const coll = collection(db, "users");

      const snap = await getDocs(
        query(
          coll,
          where("verificationStatus", "in", [
            "pending",
            "verified",
            "rejected",
          ])
        )
      );

      const arr = snap.docs.map((d) => {
        const data = d.data();

        return {
          id: d.id,
          // tenta vários campos possíveis de nome para garantir
          name:
            data.name ||
            data.displayName ||
            data.userName ||
            data.nome ||
            "Usuário sem nome",
          status: data.verificationStatus || "none",
          selfieUrl: data.verifySelfieUrl || "",
          phrase: data.verifyPhrase || "",
          profession: data.profession || "",
          createdAt: data.verificationRequestedAt || null,
        };
      });

      setVerificacoes(arr);
    } catch (error) {
      console.error("Erro ao carregar verificações:", error);
      alert("Erro ao carregar verificações.");
    }
  }

  // helper para formatar data
  function formatDate(createdAt) {
    if (!createdAt) return "-";
    try {
      if (typeof createdAt.toDate === "function") {
        return createdAt.toDate().toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      if (createdAt instanceof Date) {
        return createdAt.toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      return "-";
    } catch {
      return "-";
    }
  }

  // =========================================================
  // ✅ Aprovar
  // =========================================================
  async function aprovar(item) {
    if (!window.confirm(`Aprovar verificação de ${item.name}?`)) return;

    try {
      await updateDoc(doc(db, "users", item.id), {
        verificationStatus: "verified",
        verificationReviewedAt: new Date(),
      });

      alert("Usuário verificado com sucesso!");
      loadData();
    } catch (error) {
      console.error("Erro ao aprovar verificação:", error);
      alert("Erro ao aprovar verificação.");
    }
  }

  // =========================================================
  // ❌ Recusar
  // =========================================================
  async function recusar(item) {
    if (!window.confirm(`Recusar verificação de ${item.name}?`)) return;

    try {
      await updateDoc(doc(db, "users", item.id), {
        verificationStatus: "rejected",
        verificationReviewedAt: new Date(),
      });

      alert("Solicitação recusada.");
      loadData();
    } catch (error) {
      console.error("Erro ao recusar verificação:", error);
      alert("Erro ao recusar verificação.");
    }
  }

  // Filtrar verificações por termo de busca
  const filteredVerificacoes = verificacoes.filter(v =>
    v.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (v.profession && v.profession.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Traduzir status
  const getStatusText = (status) => {
    switch(status) {
      case 'pending': return 'Pendente';
      case 'verified': return 'Verificado';
      case 'rejected': return 'Rejeitado';
      default: return status;
    }
  };

  return (
    <div className="verif-container">
      <h2 className="title">Verificações</h2>
      
      {/* Barra de busca adicionada */}
      <div className="controls-bar">
        <input 
          type="text" 
          className="search-input" 
          placeholder="Buscar por nome ou profissão..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div style={{ fontSize: '14px', color: '#666' }}>
          {filteredVerificacoes.length} de {verificacoes.length} solicitações
        </div>
      </div>

      {filteredVerificacoes.length === 0 ? (
        <div className="no-data">
          <p>{searchTerm ? "Nenhuma solicitação encontrada para sua busca." : "Nenhuma solicitação de verificação encontrada."}</p>
        </div>
      ) : (
        <table className="verif-table">
          <thead>
            <tr>
              <th>Usuário</th>
              <th>Status</th>
              <th>Enviado em</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody>
            {filteredVerificacoes.map((v) => (
              <tr key={v.id}>
                <td>
                  <div style={{ fontWeight: '600' }}>{v.name}</div>
                  {v.profession && (
                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                      {v.profession}
                    </div>
                  )}
                </td>
                <td>
                  <span className={`status ${v.status}`}>
                    {getStatusText(v.status)}
                  </span>
                </td>
                <td>{formatDate(v.createdAt)}</td>
                <td className="actions-cell">
                  <button
                    className="btn-view"
                    onClick={() => setSelectedItem(v)}
                  >
                    Ver
                  </button>

                  {v.status === "pending" && (
                    <>
                      <button
                        className="btn-approve"
                        onClick={() => aprovar(v)}
                      >
                        Aprovar
                      </button>

                      <button
                        className="btn-reject"
                        onClick={() => recusar(v)}
                      >
                        Recusar
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ========= MODAL ========= */}
      {selectedItem && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Dados enviados para verificação</h3>

            <p>
              <strong>Usuário:</strong> {selectedItem.name}
            </p>
            {selectedItem.profession && (
              <p>
                <strong>Profissão:</strong> {selectedItem.profession}
              </p>
            )}
            {selectedItem.phrase && (
              <p>
                <strong>Frase enviada:</strong> "{selectedItem.phrase}"
              </p>
            )}
            <p>
              <strong>Status atual:</strong> {getStatusText(selectedItem.status)}
            </p>

            <div className="imgs-box">
              {selectedItem.selfieUrl ? (
                <img src={selectedItem.selfieUrl} alt="Selfie do usuário" />
              ) : (
                <p style={{ color: '#999', fontStyle: 'italic' }}>
                  Nenhuma selfie enviada
                </p>
              )}
            </div>

            <div className="modal-actions">
              <button
                className="btn-close"
                onClick={() => setSelectedItem(null)}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}